import { apiGet } from 'vivino-js/apiClient';

export function fetchWinerySponsorship({ wineryId }) {
  return apiGet({
    url: `/api/wineries/${wineryId}/sponsorship`,
  });
}
